export enum Icons {
  check = 'check',
  chevronDown = 'chevronDown',
  chevronLeft = 'chevronLeft',
  close = 'close',
  down = 'down',
  refresh = 'refresh',
  plus = 'plus',
  calendar = 'calendar',
}
